import React from 'react'
import TextEditor from '../../components/textEditor/TextEditor'

const About = () => {
    return (
        <TextEditor tag_name="about_us" />
    )
}

export default About